import React from "react";
import { addFaq, updateFaq } from "../../actions/utilitiesAction";
import constant from "../../constant";
import AddQualifications from "../../component/jobs/AddQualification";
import { createEducationQualification, createJobQuestion, updateEducationQualification, updateJobQuestion } from "../../actions/JobsAction";
import AddQuestions from "../../component/jobs/AddQuestion";
import { NavigationType, useNavigate } from "react-router-dom";

const EditQuestion = () => {

    const navigation = useNavigate()

    const [response, setResponse] = React.useState({})
    const [showMsg, setShowMsg] = React.useState(false)


    const onSubmit = (model) => {
        if (model.type === 'ADD') {
            // createJobQuestion(model).then((res) => {
            //     setResponse(res)
            //     setShowMsg(true)
            //     setTimeout(() => {
            //         setShowMsg(false)
            //     }, 7000)
            // }).catch((err) => {
            //     alert(err)
            // })
        } else {
            updateJobQuestion(model).then((res) => {
                if (res.status) {
                    navigation(constant.component.listJobQuest.url)
                }
                else {
                    setResponse(res)
                    setShowMsg(true)
                    setTimeout(() => {
                        setShowMsg(false)
                    }, 7000)
                }
            }).catch((err) => {
                alert(err)
            })
        }

    }
    return (
        <React.Fragment>
            <AddQuestions onSubmit={(data) => onSubmit(data)} response={response} showMsg={showMsg} />
        </React.Fragment>
    )
}

export default EditQuestion;